const authUrls = {
    fetchAuthOptions: {
        url: '/auth/options'
    },
    loginEkyzmat: {
        url: '/auth/authEkyzmat'
    },
    logout: {
        url: 'auth/logout'
    },
    getRequestUser: {
        url: 'auth/user'
    },
    infocom: {
        fetchAuthOptions: {
            url: '/infocom/auth/options',
        },
        authenticate: {
            url: '/infocom/auth/authenticate',
        },
    },
};

export default authUrls;